import { render } from "./view.vue?vue&type=template&id=173cfd76&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Tournaments/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "173cfd76"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('173cfd76', __exports__)) {
    api.reload('173cfd76', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=173cfd76&ts=true", () => {
    api.rerender('173cfd76', render)
  })

}


export default __exports__